import React from 'react';
import { Link } from 'react-router-dom';
export default function AuthLink({ text, linkText, to, className = '' }) {
  return (
    <p className={`mt-6 text-center text-[14px] font-semibold text-[#1B1C33] ${className}`}>
      {text}{' '}
      <Link to={to} className="text-[#FEA12B] hover:underline">
        {linkText}
      </Link>
    </p>
  );
}

